<!-- <div *ngIf="!isAdd" (click)='collapse()' [ngStyle]="{'cursor': !isEditable?'pointer':''}"> -->
<div class="row" (click)='collapse()' [ngStyle]="{'cursor': !isEditable?'pointer':''}" *ngIf="!isAdd && !loadingError">
    <div class='col-sm-1 text-center'>{{objective.displayOrder}}.</div>
    <div class='col-sm-11'>{{ objective.description }}</div>
</div>

<div class='row' *ngIf='loadingMsg'>
    <div class='col-sm-12 text-center' style='padding:1.0em 0'>
        <div>{{loadingMsg}}</div>
    </div>
</div>

<div class="row" [ngClass]="{'hide':!display}">

    <app-loading [isLoading]="isLoading" *ngIf="isLoading"></app-loading>

    <div class="col-sm-12" style='padding-bottom:0.5em;' *ngIf='isLoaded' [ngStyle]="{'margin-top': !isAdd ? '2.0em' : '0'}">
        <form [formGroup]="form" (ngSubmit)="save()" novalidate>

            <div class="col-sm-12 instructions">
                <div class='pull-right action-menu-sm'>
                    <app-button-status *ngIf="isSaving || isDeleting"></app-button-status>
                    <app-edit-button-sm (click)='edit()' *ngIf="!isEditable"></app-edit-button-sm>
                    <app-movedown-button-sm (click)="move('down')" *ngIf="!isEditable && objective.sortOrder < objectives.length - 1">Move Down</app-movedown-button-sm>
                    <app-moveup-button-sm (click)="move('up')" *ngIf="!isEditable && objective.sortOrder > 0">Move Up</app-moveup-button-sm>
                    <app-delete-button-sm (click)='delete()' *ngIf="!isEditable"></app-delete-button-sm>
                    <app-save-button-sm (click)='save()' *ngIf="isEditable"></app-save-button-sm>
                    <app-cancel-button-sm (click)='cancel()' *ngIf="isEditable"></app-cancel-button-sm>
                </div>
                <div *ngIf="!isAdd">Below are details specific to this Objective.</div>
                <div *ngIf="isAdd">Enter a new Objective in the box below.</div>
            </div>

            <div class='col-sm-12 text-center error' *ngIf='errorMessage'>
                {{errorMessage}}
            </div>

            <div class="col-sm-12">
                <label>
                    Description
                    <span *ngIf="description.invalid && (description.dirty || description.touched || isSubmitted)" class="error">
                        <span *ngIf="description.errors.maxlength">&nbsp;- Too long</span>
                        <span *ngIf="description.errors.minlength">&nbsp;- Too short</span>
                        <span *ngIf="description.errors.required || description.errors.emptyInput">&nbsp; - Description is required</span>
                    </span>
                </label>
                <div *ngIf="!isEditable">{{ ( objective.description ) ? objective.description : "-" }}</div>
                <div *ngIf="isEditable">
                    <input id="description" required formControlName="description" placeholder="Description" class="form-control" maxlength="500">
                </div>
            </div>

        </form>
        <!-- <div class="col-sm-12"><pre>{{form.value|json}}</pre></div> -->
    </div>
</div>
<!-- <div class="col-sm-12"><pre>{{objective|json}}</pre></div> -->